<template>
  <!-- <div id="main-wrapper pt-0" class="show"> -->
  <div class="landing_page">
    <div class="homepage">
      <div class="container">
        <el-card class="box-card" style="margin-top: 20px; padding-top: 20px">
          <el-header style="text-align: center">
            <h1>Personal information authentication</h1>
          </el-header>
          <div class="row">
            <div class="col-xl-12 col-lg-12" style="margin-top: 40px">
              <section>
                <el-steps
                  :active="activeStep"
                  align-center
                  finish-status="success"
                >
                  <el-step title="Personal information"></el-step>
                  <el-step title="Authentication"></el-step>
                  <el-step title="Bank information"></el-step>
                  <el-step title="Additional information"></el-step>
                </el-steps>
              </section>
            </div>
          </div>
          <div class="row">
            <div
              class="col-xl-10 col-lg-10"
              style="margin-left: 10%; margin-top: 40px"
            >
              <el-form
                ref="elForm"
                :model="formData"
                :rules="rules"
                size="medium"
                label-width="100px"
                label-position="top"
              >
                <el-form-item
                  label="Please be as thorough as possible as this will help save time on additional follow up.
Are you considered to be a politically exposed person? e.g – Are they senior military, government,or political officials, or relatives or associates of such officials? Or are you closely associated with an immediate family member of a senior military, government, or political official?"
                  prop="politicalFigure"
                >
                  <el-radio-group
                    v-model="formData.politicalFigure"
                    size="medium"
                  >
                    <el-radio
                      v-for="(item, index) in politicalFigureOptions"
                      :key="index"
                      :label="item.value"
                      :disabled="item.disabled"
                      >{{ item.label }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  label="Has you ever done business in, spent significant time in or otherwise had significant contact with countries sanctioned by the U.S.? Including but not limit to: Cuba, Iraq, Libya, North Korea ,Sudan,Yemen, Iran, Lebanon, Pakistan, Syria. Check out the link above to find more information."
                  prop="usSanctions"
                >
                  <el-radio-group v-model="formData.usSanctions" size="medium">
                    <el-radio
                      v-for="(item, index) in usSanctionsOptions"
                      :key="index"
                      :label="item.value"
                      :disabled="item.disabled"
                      >{{ item.label }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  label="Employment Information"
                  prop="personalProfile"
                >
                  <el-input
                    v-model="formData.personalProfile"
                    type="textarea"
                    placeholder="Please provide the name of your current employer, your title and description of your role, as much detail as possible. 
"
                    :autosize="{ minRows: 4, maxRows: 4 }"
                    :style="{ width: '100%' }"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="Source of your income. (Salary from prior employment, Investments, Inheritance etc..)"
                  prop="incomeSource"
                >
                  <el-input
                    v-model="formData.incomeSource"
                    type="textarea"
                    placeholder="Please provide as much detail as possible regarding the activities that produce your current income."
                    :autosize="{ minRows: 4, maxRows: 4 }"
                    :style="{ width: '100%' }"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="Source of net wealth: (Salary from prior employment, Investments, Inheritance etc..)"
                  prop="assetsSource"
                >
                  <el-input
                    v-model="formData.assetsSource"
                    type="textarea"
                    placeholder="Please provide as much detail as possible regarding the activities that produced your total net worth."
                    :autosize="{ minRows: 4, maxRows: 4 }"
                    :style="{ width: '100%' }"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="How would you use this OTC account?"
                  prop="additionalInfo"
                >
                  <el-input
                    v-model="formData.additionalInfo"
                    type="textarea"
                    placeholder="The assets that you are interested to buy/sell and the estimated amount per month"
                    :autosize="{ minRows: 4, maxRows: 4 }"
                    :style="{ width: '100%' }"
                  ></el-input>
                </el-form-item>

                <el-row :gutter="20" style="margin-top: 40px">
                  <el-col :span="6" :offset="0"
                    ><el-button @click="goback">Previous</el-button></el-col
                  >
                  <el-col :span="10" :offset="6">
                    <el-form-item size="large">
                      <el-button type="primary" @click="submitForm"
                        >Submit</el-button
                      >
                      <el-button @click="resetForm">Reset</el-button>
                    </el-form-item></el-col
                  >
                </el-row>
              </el-form>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <!-- <Footer /> -->
  </div>
</template>
<script>
import {
  otc_auth_status,
  get_additional_info,
  att_additional_info,
} from "../../plugins/api/account_otc";
export default {
  components: {},
  props: [],
  data() {
    return {
      activeStep: 3,
      formData: {
        politicalFigure: "",
        usSanctions: "",
        personalProfile: undefined,
        incomeSource: undefined,
        assetsSource: undefined,
        additionalInfo: undefined,
      },
      rules: {
        politicalFigure: [
          {
            required: true,
            message:
              "Whether you are a politician or not is not an empty question",
            trigger: "change",
          },
        ],
        usSanctions: [
          {
            required: true,
            message:
              "Are you subject to U.S. sanctions, or are you from a U.S.-sanctioned area, or have you visited the region for a long time to do any business with those areas? Cannot be empty",
            trigger: "change",
          },
        ],
        personalProfile: [
          {
            required: true,
            message:
              "Please provide the name of your current employer, your title and description of your role, as much detail as possible. ",
            trigger: "blur",
          },
        ],
        incomeSource: [
          {
            required: true,
            message: "Please provide as much detail as possible regarding the activities that produce your current income.",
            trigger: "blur",
          },
        ],
        assetsSource: [
          {
            required: true,
            message:
              "Please provide as much detail as possible regarding the activities that produced your total net worth.",
            trigger: "blur",
          },
        ],
        additionalInfo: [
          {
            required: true,
            message: "The assets that you are interested to buy/sell and the estimated amount per month",
            trigger: "blur",
          },
        ],
      },
      politicalFigureOptions: [
        {
          label: "Yes",
          value: 1,
        },
        {
          label: "No",
          value: 2,
        },
      ],
      usSanctionsOptions: [
        {
          label: "Yes",
          value: 1,
        },
        {
          label: "No",
          value: 2,
        },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {
    otc_auth_status().then((res) => {
      console.log(res);
      if (res && res.data) {
        // console.log("reg attach info complete!");
      }
    });

    get_additional_info().then((res_query) => {
      if (res_query.data.usSanctions) {
        this.$Message.success("This information has been stored");
        this.formData = res_query.data;
      }
    });
  },
  mounted() {},
  methods: {
    submitForm() {
      this.$refs["elForm"].validate((valid) => {
        if (!valid) return;
        att_additional_info(this.formData).then((res) => {
          if (res.code == 0 || res.code == 18289475) {
            this.$alert(
              "You have submitted your profile and we will complete the review as soon as possible and notify you by email after the approval",
              "prompt",
              {
                confirmButtonText: "Enter",
                callback: (action) => {
                  this.$router.push("/accounts");
                },
              }
            );
            // this.$Modal.alert({
            //   title: "prompt",
            //   content:
            //     "You have submitted your profile and we will complete the review as soon as possible and notify you by email after the approval",
            //   callback: function (action) {
            //     this.$router.push("/");
            //   },
            // });
          } else {
          }
        });
      });
    },
    resetForm() {
      this.$refs["elForm"].resetFields();
    },
    goback() {
      this.$router.push("/reg/person/step3");
    },
  },
};
</script>
<style>
</style>
